import { Outlet } from "react-router-dom";

const SuperAdmin = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default SuperAdmin;
